<template>
  <!-- D: 주문현황(주문상세) -->
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">주문상세</h1>
      <!-- D: PC 전용 -->
      <div class="order-basic-info">
        <div class="item">
          <strong>주문일자</strong>
          <p>{{ data.biz1.header.erdDat }}</p>
        </div>
        <div class="item" v-if="data.biz1.header.orderNo">
          <strong>페인트 프로 주문번호</strong>
          <p>{{ data.biz1.header.orderNo }}</p>
        </div>
        <div class="item" v-if="data.biz1.header.sapOrderNo">
          <strong>SAP 주문번호</strong>
          <p>{{ data.biz1.header.sapOrderNo }}</p>
        </div>
      </div>
      <!-- // D: PC 전용 -->
    </div>

    <div class="l-content" v-if="data.page.pageLoad">
      <!-- D: MO 전용 -->
      <div class="order-basic-info">
        <div class="item">
          <strong>주문일자</strong>
          <p>{{ data.biz1.header.erdDat }}</p>
        </div>
        <div class="item" v-if="data.biz1.header.orderNo">
          <strong>페인트 프로 주문번호</strong>
          <p>{{ data.biz1.header.orderNo }}</p>
        </div>
        <div class="item" v-if="data.biz1.header.sapOrderNo">
          <strong>SAP 주문번호</strong>
          <p>{{ data.biz1.header.sapOrderNo }}</p>
        </div>
      </div>
      <!-- // D: MO 전용 -->
      <!-- D: 주문상세 페이지 -->
      <div class="p-order-detail-wrap">
        <div
          class="line-black-box"
          v-if="
            data.biz1.header.statCd == '0' ||
            data.biz1.header.statCd == '1' ||
            data.biz1.header.statCd == 'A' ||
            data.biz1.header.statCd == 'B'
          "
        >
          <div class="flex-box">
            <div class="c-process-area type-bubble">
              <div class="c-process type-order-detail">
                <ol>
                  <li
                    :class="{ 'is-current': data.biz1.header.statCd == '0' }"
                    :aria-current="
                      data.biz1.header.statCd == '0' ? 'step' : null
                    "
                  >
                    <span class="step-circle"></span>
                    <span class="text">주문대기</span>
                  </li>
                  <!-- D: 현재 단계 is-current 추가 -->
                  <li
                    :class="{ 'is-current': data.biz1.header.statCd == '1' }"
                    :aria-current="
                      data.biz1.header.statCd == '1' ? 'step' : null
                    "
                  >
                    <span class="step-circle"></span>
                    <span class="text">주문접수</span>
                  </li>
                  <li
                    :class="{ 'is-current': data.biz1.header.statCd == 'A' }"
                    :aria-current="
                      data.biz1.header.statCd == 'A' ? 'step' : null
                    "
                  >
                    <span class="step-circle"></span>
                    <span class="text">제품준비</span>
                  </li>
                  <li
                    :class="{ 'is-current': data.biz1.header.statCd == 'B' }"
                    :aria-current="
                      data.biz1.header.statCd == 'B' ? 'step' : null
                    "
                  >
                    <span class="step-circle"></span>
                    <span class="text">배송중</span>
                  </li>
                  <li>
                    <span class="step-circle"></span>
                    <span class="text">배송완료</span>
                  </li>
                </ol>
              </div>

              <template v-if="data.biz1.header.vdatu">
                <div class="c-bubble">
                  <span class="label">배송요청일</span>
                  <p class="text">
                    <b>{{ data.biz1.header.vdatu }}</b>
                  </p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="line-black-box" v-if="data.biz1.header.statCd == 'C'">
          <div class="flex-box">
            <div class="c-process-area type-result">
              <div class="order-result-box">
                <strong class="label">배송완료</strong>
                <p class="text" v-if="data.biz1.header.ztransDate">
                  {{ data.biz1.header.ztransDate }}&nbsp;도착했습니다.
                </p>
              </div>
              <div class="c-process type-order-detail">
                <ol>
                  <li>
                    <span class="step-circle"></span>
                    <span class="text">주문대기</span>
                  </li>
                  <li>
                    <span class="step-circle"></span>
                    <span class="text">주문접수</span>
                  </li>
                  <li>
                    <span class="step-circle"></span>
                    <span class="text">제품준비</span>
                  </li>
                  <li>
                    <span class="step-circle"></span>
                    <span class="text">배송중</span>
                  </li>
                  <!-- D: 현재 단계 is-current 추가 -->
                  <li class="is-current" aria-current="step">
                    <span class="step-circle"></span>
                    <span class="text">배송완료</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div class="line-black-box" v-if="data.biz1.header.statCd == 'C2'">
          <div class="flex-box">
            <div class="order-result-box">
              <strong class="label">{{ data.biz1.header.statNm }}</strong>
              <p class="text">
                {{ data.biz1.header.canDate }} {{ data.biz1.header.canTime }}
              </p>
            </div>
          </div>
        </div>

        <div class="white-sheet-area">
          <div class="info-table-box">
            <h2 class="c-title-level3">주문자 정보</h2>
            <!-- D: PC 전용 -->
            <div class="c-table-horizontal only-pc">
              <table>
                <caption>
                  주문자 정보 테이블
                </caption>
                <colgroup>
                  <col style="width: 200px" />
                  <col />
                  <col style="width: 200px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">주문자</th>
                    <td>
                      {{ data.biz1.header.zbpName }} /
                      {{ data.biz1.header.j1kfrepre }} ({{
                        data.biz1.header.telf2D
                      }})
                    </td>
                    <th scope="row">담당지점/영업사원</th>
                    <td>
                      {{ data.biz1.header.zdeptName }} /
                      {{ data.biz1.header.zempName }} ({{
                        data.biz1.header.zphoneNo
                      }})
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-table-horizontal only-mo">
              <table>
                <caption>
                  주문자 정보 테이블
                </caption>
                <colgroup>
                  <col style="width: 110px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">주문자</th>
                    <td>
                      {{ data.biz1.header.zbpName }} /
                      {{ data.biz1.header.j1kfrepre }} ({{
                        data.biz1.header.telf2D
                      }})
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">담당지점/<br />영업사원</th>
                    <td>
                      {{ data.biz1.header.zdeptName }} /
                      {{ data.biz1.header.zempName }} ({{
                        data.biz1.header.zphoneNo
                      }})
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- // D: MO 전용 -->
          </div>
          <div class="info-table-box">
            <h2 class="c-title-level3">배송 정보</h2>
            <!-- D: PC 전용 -->
            <div class="c-table-horizontal only-pc">
              <table>
                <caption>
                  배송 정보 테이블
                </caption>
                <colgroup>
                  <col style="width: 200px" />
                  <col />
                  <col style="width: 200px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">배송방법</th>
                    <td >
                      <b>{{ data.biz1.header.dlvMthdNm }}</b>
                    </td>
                    <th scope="row">운송장번호</th>
                    <td>
                      <b>{{ data.biz1.header.zzinvoiceParcel }}&nbsp;</b>
                      <button
                            type="button"
                            class="c-util-button type-line-black type-small"
                            @click="
                              goFreightSerch(data.biz1.header.zzinvoiceParcel)
                            "
                          >
                            <span>운송장 조회</span>
                          </button>
                    </td>
                  </tr>
                  <template
                    v-if="
                      data.biz1.header.dlvMthdCd == '10' ||
                      data.biz1.header.dlvMthdCd == '15' ||
                      data.biz1.header.dlvMthdCd == '18'
                    "
                  >
                    <tr>
                      <th scope="row">받는분/주소</th>
                      <td colspan="3">
                        {{ data.biz1.header.bname }} / ({{
                          data.biz1.header.postCode1
                        }}) {{ data.biz1.header.addr }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '20'">
                    <tr>
                      <th scope="row">지역/지점</th>
                      <td colspan="3">
                        {{ data.biz1.header.dlvRgnCd }} /
                        {{ data.biz1.header.dlvBranchCd }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '25'">
                    <tr>
                      <th scope="row">받는분/주소</th>
                      <td colspan="3">
                        {{ data.biz1.header.bname }} /
                        {{ data.biz1.header.addr }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '30'">
                    <tr>
                      <th scope="row">출고지</th>
                      <td colspan="3">
                        {{ data.biz1.header.werks }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '20' || data.biz1.header.dlvMthdCd == '30'">
                    <tr>
                      <th scope="row">인수자명</th>
                      <td colspan="3">
                        {{ data.biz1.header.bname }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd != '30'">
                    <tr>
                      <th scope="row">휴대폰번호</th>
                      <td v-if="data.biz1.header.telf3 ==''">{{ data.biz1.header.telf2D }}</td>
                      <td v-if="data.biz1.header.telf3 !=''">{{ data.biz1.header.telf3 }}</td>
                      <th scope="row">휴대폰번호 (추가)</th>
                      <td>{{ data.biz1.header.telf4 }}</td>
                    </tr>
                  </template>
                  <tr>
                    <th scope="row">배송요청사항</th>
                    <td colspan="3">{{ data.biz1.header.dlvDmndCn }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-table-horizontal only-mo">
              <table>
                <caption>
                  배송 정보 테이블
                </caption>
                <colgroup>
                  <col style="width: 110px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">배송방법</th>
                    <td>
                      <b>{{ data.biz1.header.dlvMthdNm }}</b>
                    </td>
                    <th scope="row">운송장번호</th>
                    <td>
                      <b>{{ data.biz1.header.zzinvoiceParcel }}</b>
                      <button
                            type="button"
                            class="c-util-button type-line-black type-small"
                            @click="
                              goFreightSerch(data.biz1.header.zzinvoiceParcel)
                            "
                          >
                            <span>운송장 조회</span>
                          </button>
                    </td>
                  </tr>
                  <template
                    v-if="
                      data.biz1.header.dlvMthdCd == '10' ||
                      data.biz1.header.dlvMthdCd == '15' ||
                      data.biz1.header.dlvMthdCd == '18'
                    "
                  >
                    <tr>
                      <th scope="row">받는분/주소</th>
                      <td colspan="3">
                        {{ data.biz1.header.bname }} / ({{
                          data.biz1.header.postCode1
                        }}) {{ data.biz1.header.addr }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '20'">
                    <tr>
                      <th scope="row">지역/지점</th>
                      <td colspan="3">
                        {{ data.biz1.header.dlvRgnCd }} /
                        {{ data.biz1.header.dlvBranchCd }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '25'">
                    <tr>
                      <th scope="row">받는분/주소</th>
                      <td colspan="3">
                        {{ data.biz1.header.bname }} /
                        {{ data.biz1.header.addr }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '30'">
                    <tr>
                      <th scope="row">출고지</th>
                      <td colspan="3">
                        {{ data.biz1.header.werks }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd == '20'">
                    <tr>
                      <th scope="row">인수자명</th>
                      <td colspan="3">{{ data.biz1.header.bname }}</td>
                    </tr>
                  </template>
                  <template v-if="data.biz1.header.dlvMthdCd != '30'">
                    <tr>
                      <th scope="row">휴대폰번호</th>
                      <td colspan="3" v-if="data.biz1.header.telf3 ==''">{{ data.biz1.header.telf2D }}</td>
                      <td colspan="3" v-if="data.biz1.header.telf3 !=''">{{ data.biz1.header.telf3 }}</td>
                    </tr>
                    <template v-if="data.biz1.header.telf4">
                      <tr>
                        <th scope="row">휴대폰번호 (추가)</th>
                        <td colspan="3">{{ data.biz1.header.telf4 }}</td>
                      </tr>
                    </template>
                  </template>
                  <tr>
                    <th scope="row">배송요청사항</th>
                    <td colspan="3">{{ data.biz1.header.dlvDmndCn }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- // D: MO 전용 -->
          </div>
          <div class="c-util-box">
            <div class="text-box">
              <span>주문 제품 {{ data.biz1.header.mcnt }}개</span>
              <span
                >총 주문 금액
                {{ Number(data.biz1.header.goodsPrc).toLocaleString() }}원</span
              >
            </div>
          </div>
          <div class="order-table-box">
            <!-- D: PC 전용 -->
            <div class="scroll-x only-pc">
              <div class="scroll-x-inner">
                <div class="c-table" style="width: 1280px">
                  <table>
                    <caption>
                      주문 리스트 테이블
                    </caption>
                    <colgroup>
                      <col style="width: 454px" />
                      <col style="width: 90px" />
                      <col style="width: 90px" />
                      <col style="width: 120px" />
                      <col style="width: 100px" />
                      <col style="width: 100px" />
                      <col style="width: 100px" />
                      <!-- <col style="width: 100px" /> -->
                      <col style="width: 100px" />
                      <col style="width: 120px" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col">제품</th>
                        <th scope="col">용량</th>
                        <th scope="col">주문수량</th>
                        <th scope="col">주문금액</th>
                        <th scope="col">확정수량</th>
                        <th scope="col">취소수량</th>
                        <th scope="col">주문상태</th>
                        <!-- <th scope="col">취소자</th> -->
                        <th scope="col">취소사유</th>
                        <th scope="col">취소일시</th>
                      </tr>
                    </thead>
                    <tbody>
                      <OrderListDetailRow
                        v-for="(item, index) in data.biz1.list"
                        :key="index"
                        :item="item"
                        :zempName="data.biz1.header.zempName"
                        @detail="(item) => openProdInfoPop(item)"
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-products only-mo">
              <MoOrderListDetailRow
                v-for="(item, index) in data.biz1.list"
                :key="index"
                :item="item"
                :zempName="data.biz1.header.zempName"
                @detail="(item) => openProdInfoPop(item)"
              />
            </div>
            <!-- // D: MO 전용 -->
          </div>
        </div>
      </div>
      <!-- // D: 주문상세 페이지 -->
    </div>

    <ProdInfoPop
      v-if="isShowProdInfoPop"
      v-bind="prodInfoPopProps"
      @close="() => (isShowProdInfoPop = false)"
    />

    <QuickMenu />
  </div>
</template>
<script setup>
import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import { inject, onMounted, provide, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import * as orderApi from "@/api/orderApi.js";
const { isMobile } = cmUtil.useDeviceType();
import { api } from "@/plugins/api";
import router from "@/router";
import OrderListDetailRow from "@/components/paintpro/order/orderListDetailRow.vue";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";
import MoOrderListDetailRow from "@/components/paintpro/order/moOrderListDetailRow.vue";

const route = useRoute();
const url = inject("url_prefix");

const prodInfoPopProps = ref({ matnr: null });
const isShowProdInfoPop = ref(false);

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {},
    query: {},
    deviceType: isMobile.value ? "M" : "P",
    orderSn: "",
    path: "",
    empIndex: 0,
    selectedBranch: {},
    pageLoad: false,
  },
  codes: {
    code01: [], // 주문상태코드
    code02: [],
  },
  popup: {
    isShowProdInfoPop: false, // 제품상세
  },
  // 주문내역 주문서
  biz1: {
    mode: "", // 모드 {"", "new", "view", "edit"}
    search: {},
    search_init: {}, // 검색 파라메터 초기값
    header: {},
    list: [], // 목록
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    loading: false,
    detail: {
      sample02Sn: 0,
      col01: "",
      col02: "",
      col03: "",
      col04: "",
      col05: "",
      col06: "",
      useYn: "Y",
    },
  },
  eventBus: {
    salesPersonIndex: 0,
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  data.page.orderSn = route.params.id;

  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  searchCmd("biz1#orderDetail");
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    return false;
  }

  data.page.path = route.path;
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;

  // 영업사원 디폴트
  data.eventBus.salesPersonIndex = store.useEventBusStore()?.salesPersonIndex;
  data.page.selectedBranch =
    data.page.userLoginInfo.empList[data.eventBus.salesPersonIndex];
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "") {
  if (cmd === "biz1#orderDetail") {
    // ◼◼◼ biz1 조회
    cmUtil.loading("조회중입니다");
    data.biz1.loading = true;
    const res = await api.get(`${url}/order/selectOrderListByOrderDetail`, {
      params: {
        orderSn: data.page.orderSn,
        start: 0,
        limit: 1,
      },
    });
    if (
      res.data.orderHeader.length === 0 ||
      res.data.orderDetail.length === 0
    ) {
      cmUtil.loadingHide();
      await cmUtil.alert("주문상세 정보가 없습니다.");
      router.push({
        path: "/paintpro/orderList",
      });
    }
    data.biz1.header = res.data.orderHeader[0] || {};
    data.biz1.list = res.data.orderDetail;
    data.biz1.loading = false;
    data.page.pageLoad = true;
    cmUtil.loadingHide();
  }
}

// 제품 상세 팝업
function openProdInfoPop(item) {
  prodInfoPopProps.value.matnr = item.matnr;
  isShowProdInfoPop.value = true;
}

function goFreightSerch(params) {
  const url = "https://www.ds3211.co.kr/freight/internalFreightSearch.ht?billno="+params.replace(/-/g, "");
  window.open(url, '_blank');
}

// 상세팝업에서 장바구니 담기
const addCartItem = async (param = { product: null, quantity: 0 }) => {
  await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    goodsQty: param.quantity,
    vwerk: data.page.userLoginInfo.vwerk,
    zzlqdCls: param.product.zzlqdCls,
  });
};
provide("addCartItem", addCartItem);

// 상세팝업에서 바로주문
const addBuyItem = async (product) => {
  const param = {
    goodsSn: product.goodsSn,
    goodsQty: product.quantity,
    zempNo: data.page.selectedBranch.kunn2,
    path: data.page.path,
  };
  await orderApi.createTempOrder(param);
};
provide("addBuyItem", addBuyItem);

// GNB 영업사원 리스트 연동
watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  async (newValue) => {
    if (newValue >= 0 && data.page.userLoginInfo?.empList?.length > newValue) {
      data.page.empIndex = newValue;
      data.page.selectedBranch =
        data.page.userLoginInfo.empList[data.page.empIndex];
    }
  }
);

watch(
  () => route.params.id,
  (newValue) => {
    data.page.orderSn = newValue;
    searchCmd("biz1#orderDetail");
  }
);
</script>
